import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, ContextChange, HttpService, ResponseMessage, WidgetStyle } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RFIDCardProtocol, RFIDCardProtocolEntry } from '../model/rfid-card-protocol.model';

@Component({
  selector: 'app-rfid-card-protocol',
  templateUrl: './rfid-card-protocol.component.html',
  styleUrls: ['./rfid-card-protocol.component.scss']
})
export class RFIDCardProtocolComponent extends AbstractWidgetComponent implements OnInit {

  refreshEnabled = true;
  refreshInterval = 10000;
  refreshTimer: Subscription;

  columnsToDisplay = ['usageTimestamp', 'usageLocation', 'rfidCardNumber', 'rfidCardTechnicalIdentifier', 'rfidCardDescription', 'accessAllowed', 'filler'];

  responseMessages: ResponseMessage[];
  isLoading = false;

  rfidCardProtocol: RFIDCardProtocol;

  dataSource = new MatTableDataSource(new Array<RFIDCardProtocolEntry>());


  constructor(
    private httpService: HttpService,
    public translationService: TranslationService) {
    super();
  }

  ngOnInit() {
    this.load();
    this.registerRefreshTimer();
  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (environment.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.load();
      });
    } else {
      console.log('refresh timer for rfid card protocol disabled');
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.refreshEnabled = this.widgetReference.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 10 * 1000;
    }
    this.registerRefreshTimer();
  }

  private load() {
    this.isLoading = true;
    this.responseMessages = [];
    this.httpService.postWithContext<RFIDCardProtocol>(environment.rfidCardProtocolAdminEndpoint, {}).subscribe(rfidProtocol => {
      this.rfidCardProtocol = new RFIDCardProtocol(rfidProtocol);
      this.buildTableDataSource();
      this.isLoading = false;
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  private buildTableDataSource() {
    const data = new Array<RFIDCardProtocolEntry>();
    if (this.rfidCardProtocol.protocolEntries != null) {
      data.push(...this.rfidCardProtocol.protocolEntries);
    }
    this.dataSource = new MatTableDataSource(data);
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
